module.exports = __webpack_public_path__ + "img/dead-p.f3d8e87b.png";